/* unplugin-vue-components disabled */import { render } from "./Main.vue?vue&type=template&id=685c0c42&scoped=true"
import script from "./Main.vue?vue&type=script&lang=js"
export * from "./Main.vue?vue&type=script&lang=js"

import "./Main.vue?vue&type=style&index=0&id=685c0c42&scoped=true&lang=scss"

import exportComponent from "D:\\Develop\\Workspaces\\WeApp\\blockchain_ait_h5\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-685c0c42"]])

export default __exports__